var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRuler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.27269 2.78099C9.31405 1.73969 11.0024 1.73967 12.0438 2.78094L13.2171 3.95418C14.2612 4.99816 14.2613 6.69091 13.2173 7.73496L7.73519 13.217C6.69119 14.261 4.99853 14.261 3.95453 13.217L2.78105 12.0435C1.73963 11.0021 1.73965 9.31363 2.78111 8.27224L8.27269 2.78099ZM11.101 3.7238C10.5803 3.20317 9.73615 3.20318 9.21547 3.72383L3.72389 9.21508C3.20316 9.73577 3.20315 10.58 3.72386 11.1007L4.89734 12.2742C5.42064 12.7975 6.26908 12.7975 6.79238 12.2742L12.2744 6.79215C12.7978 6.26882 12.7977 5.42034 12.2744 4.89704L11.101 3.7238Z",
    fill: "#031D42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17433 4.23855L8.07966 3.33325L9.81249 5.06611C10.0625 5.31611 10.0625 5.72144 9.81249 5.97144C9.56249 6.22144 9.15717 6.22144 8.90718 5.97144L7.17433 4.23855Z",
    fill: "#031D42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25382 6.15899L6.15916 5.25368L7.89204 6.9866C8.14203 7.2366 8.14203 7.64193 7.89204 7.89193C7.64204 8.14193 7.23672 8.14193 6.98673 7.89193L5.25382 6.15899Z",
    fill: "#031D42"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33331 8.07942L4.23865 7.17412L5.97159 8.90709C6.22158 9.15709 6.22158 9.56242 5.97159 9.81242C5.72159 10.0624 5.31627 10.0624 5.06628 9.81242L3.33331 8.07942Z",
    fill: "#031D42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuler);
export default __webpack_public_path__ + "static/media/ruler.795dc440.svg";
export { ForwardRef as ReactComponent };